import React from 'react';
import { cn } from '@/utils/cn';
import Text from '../Text';

function CommonBadge({ title = 'Title', className = '' }) {
  return (
    <div className="w-max bg-brilliant-white2 flex items-center gap-0.5 lg:gap-[4px] px-6 lg:px-10 py-4 rounded-[100px]">
      <Text
        type="paragraph"
        className={cn(
          'text-xs lg:text-sm text-coarse-wool font-semibold whitespace-pre',
          className,
        )}
      >
        {title}
      </Text>
    </div>
  );
}

export default CommonBadge;
